import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'splitType',
  allowInfiniteLoader: () => false,
  allowSearch: () => false,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.splitType,
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.splitType = each.id
      draft.splitDistributionText = null
    }),
})()
